import { ranking } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            吃瓜热度榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时热度排名，看看大家都在关注哪些劲爆话题
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {ranking.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 hover:bg-background-100 rounded-xl transition-colors group cursor-pointer"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center font-extrabold text-sm flex-shrink-0 ${
                i < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate font-heading">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
                <i className={`text-sm ${item.trend === 'up' ? 'text-primary-500 ri-arrow-up-line' : 'text-foreground-400 ri-arrow-down-line'}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}